export const getUrl = filename => {
  return (
    // @ts-ignore
    process.env.REACT_APP_SERVER_API_DOMAIN +
    // @ts-ignore
    process.env.REACT_APP_CREDIT_DOCUMENTS_URI +
    filename
  );
};

export const parseFetchError = error => {
  if (error.message.indexOf('Failed to fetch') >= 0) {
    return `No se puede conectar al servidor en este momento,
    por favor intente más tarde. `;
  } else {
    return `No se puede conectar al servidor en este momento,
    por favor intente más tarde: ${error.message}`;
  }
};
